<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9 col-12 mx-auto">
                <div class="card">
                    <div class="card-header p-3 pb-0">
                        <div
                            class="d-flex justify-content-between align-items-center"
                        >
                            <div>
                                <h6>ตะกร้าสินค้า</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-3 pt-0">
                        <hr class="horizontal dark mt-0 mb-2" />
                        <div class="row">
                            <div
                                class="col-12 col-sm-6 px-md-4"
                                v-if="cartData.length > 0"
                            >
                                <div
                                    class="row mb-2"
                                    v-for="(item, index) in cartData"
                                    :key="index"
                                >
                                    <div class="col-12">
                                        <div class="d-flex">
                                            <router-link
                                                :to="`/product/${item.id}`"
                                            >
                                                <argon-avatar
                                                    :img="imagePath + item.img"
                                                    class="me-3 mt-3"
                                                    size="xl"
                                                    border-radius="lg"
                                                    :alt="item.name"
                                                />
                                            </router-link>
                                            <div class="w-100">
                                                <router-link
                                                    :to="`/product/${item.id}`"
                                                    class="font-weight-bold text-dark mb-0 mt-2"
                                                >
                                                    {{ item.name }}
                                                </router-link>
                                                <div
                                                    class="d-flex justify-content-between align-items-center"
                                                >
                                                    <div
                                                        class="text-xs"
                                                        style="width: 140px"
                                                    >
                                                        ตัวเลือก :
                                                        {{ item.options }}
                                                        <span
                                                            v-if="
                                                                item.pair !==
                                                                'ไม่มี'
                                                            "
                                                            >+
                                                            {{
                                                                item.pair
                                                            }}</span
                                                        >
                                                    </div>
                                                    <div>
                                                        <i
                                                            class="fas fa-minus"
                                                            @click="
                                                                handleCartProductQuantity(
                                                                    index,
                                                                    item.qty,
                                                                    'minus',
                                                                )
                                                            "
                                                        ></i>
                                                        <span class="mx-2">{{
                                                            item.qty
                                                        }}</span>
                                                        <i
                                                            class="fas fa-plus"
                                                            @click="
                                                                handleCartProductQuantity(
                                                                    index,
                                                                    item.qty,
                                                                    'plus',
                                                                )
                                                            "
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div class="d-flex">
                                                    <div
                                                        class="text-sm font-weight-bold"
                                                    >
                                                        ฿{{
                                                            item.price +
                                                            item.pair_price *
                                                                item.pair_qty
                                                        }}
                                                    </div>
                                                </div>

                                                <div
                                                    class="d-flex justify-content-between align-items-center"
                                                >
                                                    <argon-badge
                                                        color="success"
                                                        variant="gradient"
                                                        size="sm"
                                                        class="mt-1"
                                                        >มีสินค้า</argon-badge
                                                    >
                                                    <i
                                                        class="fas fa-trash-alt"
                                                        @click="
                                                            removeCartProduct(
                                                                index,
                                                            )
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center py-3" v-else>
                                ไม่มีสินค้าในตะกร้า
                            </div>
                            <div class="col-12 col-sm-6 px-md-4">
                                <div class="col-12">
                                    <h6 class="mt-4 mb-0">ข้อมูลการจัดส่ง</h6>
                                    <div class="form-group">
                                        <label
                                            class="mb-0"
                                            style="margin-bottom: 0"
                                            ><span class="text-danger">*</span>
                                            เบอร์โทรศัพท์</label
                                        >
                                        <input
                                            type="phone"
                                            class="form-control"
                                            placeholder="0829394XXX"
                                            v-model="phone"
                                            maxlength="10"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-12 mb-2"
                                    v-if="
                                        cartData.length > 0 &&
                                        bankName &&
                                        bankNumber &&
                                        bankAccount
                                    "
                                >
                                    <div
                                        :style="{
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: '#e5e9ec',
                                            width: '100%',
                                            borderRadius: '6px',
                                            border: '1px solid #dde0e3',
                                            padding: '8px 15px',
                                            gap: '15px',
                                        }"
                                    >
                                        <div
                                            :style="{
                                                backgroundColor: 'white',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '100%',
                                                width: '60px',
                                                height: '60px',
                                                border: '1px solid #d9dbdc',
                                            }"
                                        >
                                            <i
                                                class="fas fa-university"
                                                style="font-size: 25px"
                                            ></i>
                                        </div>
                                        <div class="flex flex-column">
                                            <div class="fw-bold">
                                                {{ bankName }}
                                            </div>
                                            <div
                                                class="text-sm d-flex align-items-center gap-2"
                                            >
                                                <span>{{ bankNumber }}</span>
                                                <i
                                                    class="fas fa-copy"
                                                    @click="
                                                        copyToClipboard(
                                                            bankNumber,
                                                        )
                                                    "
                                                    style="
                                                        cursor: pointer;
                                                        font-size: 12px;
                                                    "
                                                    :title="`คัดลอก: ${bankNumber}`"
                                                ></i>
                                            </div>
                                            <div class="text-sm">
                                                {{ bankAccount }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 ms-auto">
                                    <h6 class="mb-3">สรุปรายการ</h6>
                                    <div class="d-flex justify-content-between">
                                        <span class="mb-2 text-sm"
                                            >ค่าสินค้า:</span
                                        >
                                        <span class="text-dark ms-2">
                                            {{ priceData?.products }}
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <span class="mb-2 text-sm"
                                            >ส่วนลด:</span
                                        >
                                        <div class="text-dark ms-2">
                                            <span>
                                                {{ priceData?.discount }}
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        class="d-flex justify-content-between"
                                        v-if="
                                            shop === 'deli' &&
                                            cartData.length != 0
                                        "
                                    >
                                        <span class="mb-2 text-sm"
                                            >ค่าจัดส่ง:</span
                                        >
                                        <span class="text-dark ms-2">{{
                                            deliPrice
                                        }}</span>
                                    </div>
                                    <div
                                        class="d-flex justify-content-between mt-4"
                                        v-if="cartData.length != 0"
                                    >
                                        <span class="mb-2 text-lg">รวม:</span>
                                        <span
                                            class="text-dark text-lg ms-2 font-weight-bold"
                                            >฿{{
                                                shop === "deli"
                                                    ? priceData?.total +
                                                      deliPrice
                                                    : priceData?.total
                                            }}</span
                                        >
                                    </div>
                                    <div class="text-end mt-3">
                                        <argon-button
                                            color="primary"
                                            variant="gradient"
                                            class="mb-0"
                                            @click="submitOrder"
                                            >ยืนยัน</argon-button
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="horizontal dark" />
                        <div class="row"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonAvatar from "@/components/ArgonAvatar.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "../services/axios";
import { mapGetters } from "vuex";
import liff from "@line/liff";

export default {
    name: "OrderDetails",
    components: {
        ArgonAvatar,
        ArgonBadge,
        ArgonButton,
    },
    data() {
        return {
            loadingSubmit: false,
            cartData: [],
            priceData: [],
            payment: "",
            name: "",
            payCashOn: "",
            phone: "",
            deliPrice: 40,
            address: {
                homeNumber: "",
                villageNumber: "",
                subdistrict: "",
                district: "",
                city: "",
                zipcode: "",
            },
            locate: "",
            text: "",
            imagePath: process.env.VUE_APP_IMAGE_PATH,
            shop: "",
            bankName: "",
            bankAccount: "",
            bankNumber: "",
        };
    },
    created() {
        this.shop = localStorage.getItem("station");

        console.log(this.Page);

        this.fetchCartData();
        this.fetchBank();
    },
    methods: {
        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    this.$swal({
                        text: "คัดลอกแล้ว",
                        icon: "success",
                        timer: 1500,
                        showConfirmButton: false,
                    });
                })
                .catch(() => {
                    this.$swal({
                        text: "ไม่สามารถคัดลอกได้",
                        icon: "error",
                    });
                });
        },
        fetchBank() {
            axios
                .get("/admin/payment")
                .then((resp) => {
                    if (
                        resp?.data?.status === "success" &&
                        resp?.data?.data?.length > 0
                    ) {
                        const bankData = resp.data.data[0];
                        this.bankName = bankData.bank || "";
                        this.bankAccount = bankData.name || "";
                        this.bankNumber = bankData.number || "";
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async submitOrder() {
            if (this.cartData.length !== 0) {
                if (!this.loadingSubmit) {
                    this.loadingSubmit = true;
                    //
                    // ส่งผ่านไรเดอร์
                    //
                    if (this.shop !== "deli" && this.phone) {
                        if (!isNaN(this.phone) && this.phone.length === 10) {
                            let allQuantity = 0;
                            let productList = [];

                            await Promise.all(
                                this.cartData.map(async (item) => {
                                    allQuantity += item.qty;

                                    productList.push(
                                        await this.setText(
                                            item.options,
                                            item.name,
                                            item.qty,
                                            item.price,
                                            item.pair_price,
                                            item.pair,
                                            item.pair_qty,
                                        ),
                                    );
                                }),
                            );

                            axios
                                .post("/order", {
                                    phoneNumber: this.phone,
                                    total: allQuantity,
                                    price: this.priceData.total,
                                    discount: this.priceData.discount,
                                    productList,
                                })
                                .then(async (resp) => {
                                    if (resp?.data?.status === "success") {
                                        liff.sendMessages([
                                            {
                                                type: "flex",
                                                altText: "คำสั่งซื้อ",
                                                contents: {
                                                    type: "bubble",
                                                    size: "hecto",
                                                    body: {
                                                        type: "box",
                                                        layout: "vertical",
                                                        contents: [
                                                            {
                                                                type: "button",
                                                                action: {
                                                                    type: "uri",
                                                                    label: "ดูรายการสั่งซื้อ",
                                                                    uri: `https://bbmshop.one/order/${resp?.data?.order}`,
                                                                },
                                                                style: "primary",
                                                                height: "sm",
                                                                margin: "md",
                                                                color: "#00ABFF",
                                                            },
                                                            {
                                                                type: "text",
                                                                text: "รอแอดมินคำนวณค่าจัดส่งสักครู่",
                                                                size: "xs",
                                                                color: "#FF8C00",
                                                                align: "center",
                                                                margin: "md",
                                                            },
                                                        ],
                                                    },
                                                },
                                            },
                                        ])
                                            .then(() => {
                                                localStorage.removeItem("cart");
                                                this.loadingSubmit = false;
                                                liff.closeWindow();
                                            })
                                            .catch(() => {
                                                alert(
                                                    "ไม่สามารถสั่งซื้อได้ กรุณาลองใหม่",
                                                );
                                                this.loadingSubmit = false;
                                                liff.closeWindow();
                                            });
                                    } else {
                                        this.$swal({
                                            text: "ไม่สามารถทำรายการได้ กรุณาลองใหม่",
                                            icon: "error",
                                        });
                                    }
                                })
                                .catch((err) => {
                                    if (err?.response) {
                                        this.$swal({
                                            text: err?.response?.data?.message
                                                ? err?.response?.data?.message
                                                : "ไม่สามารถทำรายการได้ กรุณาลองใหม่",
                                            icon: "error",
                                        });
                                    }
                                });
                        } else {
                            this.$swal({
                                text: "เบอร์โทรศัพท์ไม่ถูกต้อง",
                                icon: "error",
                            });
                            this.loadingSubmit = false;
                        }
                        //
                        // ส่งพัสดุ
                        //
                    } else {
                        this.$swal({
                            text: "กรอกข้อมูลการจัดส่งให้ครบถ้วน",
                            icon: "error",
                        });
                        this.loadingSubmit = false;
                    }
                }
            }
        },
        setText(options, name, quantity, price, pairPrice, pairName, pair_qty) {
            return new Promise((resolve) => {
                let optionText = options !== "ไม่มี" ? options : "";
                let pairText = pairName !== "ไม่มี" ? " + " + pairName : "";
                let priceText = (price + pairPrice * pair_qty) * quantity;
                let text =
                    // "\n" +
                    name +
                    " | " +
                    optionText +
                    pairText +
                    " x" +
                    quantity +
                    " = " +
                    priceText +
                    "฿";
                resolve(text);
            });
        },
        fetchCartData() {
            let shop = this.shop == "deli" ? "loei" : this.shop;
            const cart = JSON.parse(localStorage.getItem("cart"));

            if (cart) {
                axios
                    .post("/cart", {
                        cart: cart,
                        shop: shop,
                    })
                    .then(async (resp) => {
                        if (resp?.data?.status === "success") {
                            const data = resp?.data?.data?.products;
                            this.cartData = data;
                            this.priceData = resp?.data?.data?.price;

                            if (this.shop === "deli" && data.length > 0) {
                                let allQuantity = 0;
                                let uniqueTotal = 0;

                                await Promise.all(
                                    data.map(async (item) => {
                                        if (item.name.split(" ")[0] !== "ชท") {
                                            allQuantity += item.qty;
                                        } else {
                                            uniqueTotal += item.qty;
                                        }
                                    }),
                                );

                                let calDeliPrice = allQuantity * 0.6;
                                let uniqueTotalPrice = uniqueTotal * 1.5;

                                if (calDeliPrice + uniqueTotalPrice > 40) {
                                    this.deliPrice = Math.ceil(
                                        calDeliPrice + uniqueTotalPrice,
                                    );
                                } else {
                                    this.deliPrice = 40;
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        if (err?.response) {
                            console.log(err?.response?.data);
                        }
                    });
            }
        },
        handleCartProductQuantity(id, quantity, state) {
            let newQuantity;

            if (state === "minus") {
                if (quantity > 1) {
                    newQuantity = quantity - 1;
                } else {
                    return;
                }
            }
            if (state === "plus") {
                newQuantity = quantity + 1;
            }

            let cart = JSON.parse(localStorage.getItem("cart"));
            cart[id].qty = newQuantity;
            localStorage.setItem("cart", JSON.stringify(cart));

            this.fetchCartData();
        },
        removeCartProduct(id) {
            this.$swal({
                text: "ลบสินค้าในตะกร้า ?",
                showCancelButton: true,
                confirmButtonText: "ยืนยัน",
                cancelButtonText: "ยกเลิก",
                reverseButtons: true,
                customClass: {
                    confirmButton: "btn bg-gradient-success",
                    cancelButton: "btn bg-gradient-danger",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let cart = JSON.parse(localStorage.getItem("cart"));
                    cart.splice(id, 1);
                    localStorage.setItem("cart", JSON.stringify(cart));

                    this.fetchCartData();
                }
            });
        },
    },
    computed: {
        ...mapGetters(["Profile"]),
        ...mapGetters(["Page"]),
    },
};
</script>

<style scoped>
.product_name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
